import { Phone, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { SITE } from "@/data/site";

export const scrollToGetStarted = (navigate) => {
  const el = document.getElementById("get-started");
  if (el) {
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
    else el.scrollIntoView({ behavior: "smooth" });
  } else {
    navigate("/contact");
  }
};

export const CallButton = ({ className = "", label, testId = "call-now-button", light = false }) => (
  <a
    href={SITE.phoneTel}
    data-testid={testId}
    className={`group inline-flex items-center justify-center gap-2.5 rounded-full px-7 py-3.5 font-display text-sm font-semibold tracking-wide transition-colors duration-300 ${
      light
        ? "border border-white/30 text-white hover:border-gold hover:text-gold"
        : "border border-navy/25 text-navy hover:border-gold hover:text-gold-dark"
    } ${className}`}
  >
    <Phone className="h-4 w-4 transition-transform duration-300 group-hover:rotate-12" />
    {label || `CALL NOW — ${SITE.phoneDisplay}`}
  </a>
);

export const GetStartedButton = ({ className = "", label = "GET STARTED", testId = "get-started-button" }) => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={() => scrollToGetStarted(navigate)}
      className={`group inline-flex items-center justify-center gap-2.5 rounded-full bg-gold px-7 py-3.5 font-display text-sm font-semibold tracking-wide text-navy transition-colors duration-300 hover:bg-gold-dark ${className}`}
    >
      {label}
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
    </button>
  );
};

export const CTARow = ({ light = false, className = "", testPrefix = "cta" }) => (
  <div className={`flex flex-wrap items-center gap-4 ${className}`}>
    <GetStartedButton testId={`${testPrefix}-get-started`} />
    <CallButton light={light} testId={`${testPrefix}-call-now`} />
  </div>
);
